<!-- #region HTML --><template>
    <md-card class="form-container">

        <div class="delete-container">
            <h4 class="text-left flex-siblings">
                <label>サービス情報</label>
                <img src="@/assets/img/stripe-icon.svg" style="height:40px;width:40px;">
            </h4>

                <div class="flex-siblings-responsive">
                    <h4 class="theme-primary-text ">英辞郎 on the WEB Pro</h4>
                    <h4 class="theme-primary-text"><slot name="course"></slot></h4>
                </div>
                <p class="text-left text-secondary">有効期間：<slot name="expireDate"></slot> までご利用をいただけます。</p>
                <br>
        </div>
        <div class="delete-container">
            <h4 class="text-left">
                <label>アカウント削除</label>
            </h4>
            <p class="text-left theme-secondary-text"> ご注意ください。 <br>アカウントを削除すると、登録されたメールアドレスIDとパスワード、検索履歴、単語帳永久に失われ、直ちに検索サービスを利用できなくなります。</p>
            <p class="text-left theme-secondary-text"> 「英辞郎 on the WEB Pro」の利用期間が残っていた場合も同様です。</p>
            <p class="text-left">返金は承っておりませんので、「英辞郎 on the WEB Pro」の利用期間終了後にアカウントを削除することをご検討ください。</p>
            <p class="text-left">※「英辞郎 on the WEB Pro」の利用期限を確認するのは<a class="txt-decor-underline theme-primary-text" target="blank" href="https://eow-support.alc.co.jp/hc/ja/articles/33934476566169-%E3%82%B5%E3%83%96%E3%82%B9%E3%82%AF%E3%83%AA%E3%83%97%E3%82%B7%E3%83%A7%E3%83%B3%E3%81%AE%E5%81%9C%E6%AD%A2">こちら</a>。</p>
            <p class="text-left">ご質問がございましたら、<a class="txt-decor-underline theme-primary-text" target="blank" href="https://eow-support.alc.co.jp/hc/ja/requests/new" >お問い合わせフォーム</a>からご連絡ください。</p>
            <md-card-actions class="pt-10 pb-10">
                <slot name="button"></slot>
            </md-card-actions>
        </div>
    </md-card>
</template>
<!-- #endregion -->
<!-- #region JavaScript -->
<script>
export default {
    data() {
        return {
            isChecked: false,
        };
    },
};
</script>
<!-- #endregion -->